/**
 * Created by HTZ on 2019/6/21.
 */
import Vue from "vue";
import $ from "jquery";
import {
  Message
} from 'element-ui';
import hUrl from "@/utils/url";
$.ajaxSetup({
  global: true,
  cache: false,
  beforeSend: function(request) {
    var time = Vue.ls.get('lastTime')
   if (time) {
      var s = new Date().getTime()
      if (s - time > 1000 * 60 * 30) {
        Vue.ls.remove("token");
        Vue.ls.remove("lastTime");
        parent.location.href = './login';
        return
      }

    }
    Vue.ls.set('lastTime', new Date().getTime());

    var number = Vue.ls.get('number')
    if (number) {
      number = parseFloat(number) +1
       if (number>70000) {
         var number2 = Vue.ls.get('number2')

         number2 = number2 ||0
         number2 ++
         Vue.ls.set('number2', number);
         if(number2>2000){
           Vue.ls.set('number', 1);
           Vue.ls.set('number2', 0);
         }
         parent.location.href = '/404';
         return
       }

     }else{
       number =1
     }
     Vue.ls.set('number', number);

    request.setRequestHeader("Authorization", "Bearer " + Vue.ls.get('token'));

  },
  complete: function(xhr, settings) {
    var statuscode = xhr.status;
    var res = xhr.responseText && JSON.parse(xhr.responseText) || {};
    if (statuscode == 200) {
      res.error_code = 0;
      // res.error_code = res.status==1?0:1;
    }
    if (statuscode == 422) {
      var msgarr = [res.message];
      for (var name in res.errors) {
        msgarr = msgarr.concat(res.errors[name] || []);
      }
      Message({
        message: String(msgarr.join('<br/>')),
        dangerouslyUseHTMLString: true,
        time: 500 //2秒关闭（如果不配置，默认是3秒）
      }, function() {});
    }
    if (statuscode == 401) {
      // alert(res.message);
      Vue.ls.remove("token");
      parent.location.href = './login';
    }
  },
  error: function(xhr) {
    Message({
      message: xhr.responseJSON ? xhr.responseJSON.message : String(xhr.statusText),
      type: 'error',
      showClose: true
    });
    // $(document).data("_currentPageVue").loading=false;
  },
  success: function(res) {

  },
  //http码是200时进以下方法
  dataFilter: function(responseText, dataType) {
    var res = {};
    try {
      var oldresult = responseText && JSON.parse(responseText) || {};
      oldresult.error_code = 0;
      oldresult.error_msg = oldresult.message;
      res = oldresult;
      // res.error_code = !oldresult.message?0:1;
      // res.message = !oldresult.message?'操作成功':oldresult.message;
      // res.data=oldresult;
    } catch (e) {
      res = {
        error_code: 1,
        error_msg: responseText,
        data: {}
      };
    }
    responseText = JSON.stringify(res);
    return responseText;
  },
  statusCode: {
    404: function() {},
    401: function() {},
    422: function() {}
  }
});

function applyHeaders(xhr, obj) {
  for (var key in obj) {
    xhr.setRequestHeader(key, obj[key]);
  }
}

function ajax2(astype, data, url, successCall, errorCall, showloading, async) {

  $.ajax({
    type: astype,
    data: data,
    url: hUrl + url,
    dataType: 'json',
    success: function(res) {
      successCall(res)
    },
    error: function(res) {
      if (errorCall) {
        errorCall(res.responseJSON)
      } else {
        Message({
          message: String(res.responseJSON ? res.responseJSON.message : res.statusText),
          type: 'error',
          showClose: false
        });

      }

    },
    showloading: showloading,
    async: async
  })
}

function ajax3(astype, data, url, successCall, filename, filetype, errorCall) {
  $.ajax({
    type: astype,
    data: data,
    url: hUrl + url,
    xhrFields: {
      responseType: 'blob'
    },
  }).done(function(response) {
    let blob = new Blob([response], {
      type: filetype || 'application/vnd.ms-excel'
    })
    let fileName = filename || Date.parse(new Date()) + '.xlsx'
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, fileName)
    } else {
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      link.click();
      //释放内存
      window.URL.revokeObjectURL(link.href)
    }
    successCall && successCall();
  }).fail(function(xhr) {
    Message({
      message: String(xhr.responseJSON ? xhr.responseJSON.message : xhr.statusText),
      type: 'error',
      showClose: true
    });
    errorCall && errorCall(xhr);
  })
}

function ajax4(astype, data, url, successCall, errorCall) {
  var formData = new FormData();
  $.each(data, function(i, v) {
    formData.append(i, v);
  });
  $.ajax({
    url: hUrl + url,
    type: astype,
    data: formData,
    success: successCall,
    error: errorCall,
    contentType: false, //必须false才会自动加上正确的Content-Type
    processData: false //必须false才会避开jQuery对 formdata 的默认处理
  });
}


function gitAjax(astype, data, url, successCall, errorCall, showloading, async) {

  $.ajax({
    type: astype,
    data: data,
    url:   url,
    dataType: 'json',
    success: function(res) {
      successCall(res)
    },
    error: function(res) {
      if (errorCall) {
        errorCall(res.responseJSON)
      } else {
        Message({
          message: String(res.responseJSON ? res.responseJSON.message : res.statusText),
          type: 'error',
          showClose: false
        });

      }

    },
    showloading: showloading,
    async: async
  })
}
export const ajax = ajax2;
export const exportajax = ajax3;
export const importajax = ajax4;
export const gitajax = gitAjax;



// WEBPACK FOOTER //
// ./src/api/jqajax.js